import React from "react";
import "../../styles/About.css";
import {
  FaUsers,
  FaChartLine,
  FaHandshake,
  FaClipboardCheck,
} from "react-icons/fa";

function Whychoose() {
  const points = [
    {
      icon: <FaUsers />,
      title: "Result-Oriented Approach ",
      desc: "We focus on handing over measurable outcomes greater visitors, better scores, and higher conversions for your commercial enterprise.",
    },
    {
      icon: <FaChartLine />,
      title: "SEO-Optimized Development",
      desc: "Every website we build is designed with search engine marketing excellent practices, helping you rank for key phrases like net development organisation near me and grow organically.",
    },
    {
      icon: <FaHandshake />,
      title: "Fast & Reliable Delivery ",
      desc: "We cost your time. Our streamlined method guarantees timely shipping without compromising exceptional.",
    },
    {
      icon: <FaClipboardCheck />,
      title: "Affordable Pricing",
      desc: "Get top rate virtual services at fee-effective pricing, making it less complicated for corporations of all sizes to develop on-line.",
    },
  ];

  return (
    <>
    <section className="whychose">
      <div className="why-head">
        <h3>Why choose Empower Web?</h3>
        <p>
          Choosing the proper virtual companion could make all of the difference
          for your business growth. At Empower Web, we don’t just construct web
          sites we create powerful virtual solutions that assist you attract,
          engage, and convert your audience correctly.{" "}
        </p>
      </div>

      <div className="why-grid">
        {points.map((item, index) => (
          <div className="why-card" key={index}>
            <div className="why-icon">{item.icon}</div>
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>

    
    </>
  );
}

export default Whychoose;
